"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachedFileRows = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = require("../../../../Button/Button");
const Text_1 = require("../../../../Text/Text");
const ComposeContext_1 = require("../../ComposeContext");
const AttachedFileImagePreview_1 = require("./AttachedFileImagePreview");
const AttachedFileList_1 = require("./AttachedFileList");
const AttachedFileListContext_1 = require("./AttachedFileListContext");
const StyledFileRow = styled_components_1.default.div `
    border-bottom: 1px solid lightgray;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const StyledCenterPreview = styled_components_1.default.div `
    align-items: center;
    display: flex;
`;
const StyledImagePreview = styled_components_1.default.div `
    display: inline-block;
`;
const StyledTruncatedText = (0, styled_components_1.default)(Text_1.Text) `
    margin: 0;
    word-break: break-word;
`;
const AttachedFileRows = ({ customRenderFileRow, }) => {
    const { uploadedFiles, isUploadingFile, isSending, setUploadedFiles } = (0, ComposeContext_1.useCompose)();
    const { registerSubComponent } = (0, AttachedFileListContext_1.useAttachedFileList)();
    const [disableInputs, setDisableInputs] = (0, react_1.useState)(true);
    // Register this sub-component to the parent context
    (0, react_1.useEffect)(() => {
        registerSubComponent(AttachedFileList_1.AttachedFileListSubComponent.Rows);
    }, []);
    (0, react_1.useEffect)(() => {
        setDisableInputs(isUploadingFile || isSending);
    }, [isUploadingFile, isSending]);
    const removeFile = (attachmentId) => {
        setUploadedFiles &&
            setUploadedFiles(uploadedFiles.filter((x) => x.attachmentId !== attachmentId));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, uploadedFiles.map((file, i) => {
        if (customRenderFileRow) {
            return customRenderFileRow(file, removeFile, disableInputs);
        }
        return (react_1.default.createElement(StyledFileRow, { key: file.attachmentId + " FileKey" },
            react_1.default.createElement(StyledImagePreview, null,
                react_1.default.createElement(StyledCenterPreview, null,
                    react_1.default.createElement(AttachedFileImagePreview_1.AttachedFileImagePreview, { file: file }),
                    react_1.default.createElement(StyledTruncatedText, null, file.file.name))),
            react_1.default.createElement(Button_1.Button, { theme: "danger", onClick: () => removeFile(file.attachmentId), "data-testid": "bin-icon", type: "button", "aria-label": `Delete attachment ${file.file.name}`, icon: {
                    name: "Bin",
                    style: "Line",
                    title: "",
                }, disabled: disableInputs })));
    })));
};
exports.AttachedFileRows = AttachedFileRows;
//# sourceMappingURL=AttachedFileRows.js.map